export default "__VITE_ASSET__CVtrPZM6__"